import 'bootstrap';

import '@babel/polyfill';
import 'mutationobserver-shim';
import Vue from 'vue';
import './plugins/fontawesome';
import './plugins/bootstrap-vue';
import App from './App.vue';
import router from './router';

// Vue cookies
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
Vue.$cookies.config('5d');

// Vue chatscroll
import VueChatScroll from 'vue-chat-scroll';
Vue.use(VueChatScroll);

import store from '@/store'; // Vuex
import http from '@/http'; // Axios
Vue.prototype.$http = http;

const bus = new Vue();
Vue.prototype.$bus = bus;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
